import { CalendarCheck } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { PoShipDateConfirmationPage } from './pages/PoShipDateConfirmationPage'
import { PoShippingDocumentsPage } from './pages/PoShippingDocumentsPage'

/**
 * PO Ship Date Confirmation (2026-08-25).
 *
 * Flags open inbound POs without a vendor-confirmed ship date — vs. a
 * buyer-entered `date_planned` estimate. Prompted by KCC PO1862, quoted to
 * the owner as "on the water, arriving Sept 6" off an unconfirmed
 * estimate that then slipped for a month and a half.
 *
 * Originally shipped as a tab inside the Logistics module's Freight page;
 * split into its own module/sidebar entry per Chris's follow-up request so
 * it reads as its own workflow, not a sub-view of Freight. Backed by
 * `GET/POST /api/po-shipment-confirmation*`
 * (middleware/app/models/po_shipment_confirmation.py) — a reconciler
 * auto-creates/-resolves tracker rows from live Odoo PO state, so nothing
 * here needs a create action. Odoo mirror fields live in the
 * `spi_po_ship_confirmation` module (silicones repo).
 */
export default defineModule({
  id: 'po-ship-confirmation',
  name: 'PO Ship Date Confirmation',
  shortName: 'Ship Confirmation',
  icon: CalendarCheck,
  navSection: 'logistics',
  navOrder: 30,
  urlNamespace: '/po-ship-confirmation',
  routes: [
    { path: '/', element: PoShipDateConfirmationPage, label: 'PO Ship Date Confirmation' },
    // Odoo's PO "Shipping Documents" tab deep-links here.
    { path: '/$odooPoId/documents', element: PoShippingDocumentsPage, label: 'Shipping documents' },
  ],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing'],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g s c',

  commandPaletteEntries: [
    {
      label: 'Go to PO Ship Date Confirmation',
      keywords: [
        'ship date',
        'confirmation',
        'vendor',
        'purchase order',
        'po',
        'inbound',
        'unconfirmed',
        'estimate',
        'kanban',
        'logistics',
      ],
      path: '/',
      group: 'modules',
      shortcut: 'g s c',
    },
  ],
})
